import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

type AppState = {
    marketCode: string;
    languageCode: string;
    deviceType: string;
    tipsType: string;
    isInitialized: boolean;
    /** Desktop panel layout. */
    isEmbedded: boolean;
    /** Opened by another module on one group: the group is the root view and Back returns to the host. */
    isDeepLinkEntry: boolean;
    initialGuideItemType: string | null | undefined;
};

const getInitialState = (): AppState => {
    return {
        marketCode: '',
        languageCode: '',
        deviceType: '',
        tipsType: '',
        isInitialized: false,
        isEmbedded: false,
        isDeepLinkEntry: false,
        initialGuideItemType: undefined,
    };
};

export const slice = createSlice({
    name: 'app',
    initialState: getInitialState(),
    reducers: {
        setMarketCode: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                marketCode: action.payload,
            };
        },
        setLanguageCode: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                languageCode: action.payload,
            };
        },
        setDeviceType: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                deviceType: action.payload,
            };
        },
        setTipsType: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                tipsType: action.payload,
            };
        },
        setInitialized: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isInitialized: action.payload,
            };
        },
        setIsEmbedded: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isEmbedded: action.payload,
            };
        },
        setIsDeepLinkEntry: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isDeepLinkEntry: action.payload,
            };
        },
        setInitialGuideItemType: (state, action: PayloadAction<string | undefined>) => {
            return {
                ...state,
                initialGuideItemType: action.payload,
            };
        },
    },
});

export const {
    setMarketCode,
    setLanguageCode,
    setDeviceType,
    setTipsType,
    setInitialized,
    setIsEmbedded,
    setIsDeepLinkEntry,
    setInitialGuideItemType,
} = slice.actions;
export default slice.reducer;
